module.exports = __webpack_public_path__ + "static/media/reclinersoffa.744c43a5.jpg";